const Cookie = require('js-cookie');

/**
 * Generates random string
 */
function makeToken(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default {
  deviceTokenName: 'device',

  getToken() {
    return Cookie.get(this.deviceTokenName);
  },

  setToken(token) {
    return Cookie.set(this.deviceTokenName, token, {
      sameSite: 'strict',
      expires: 365,
    });
  },

  getOrUpdateToken() {
    return this.getToken() || this.updateToken();
  },

  updateToken() {
    const token = makeToken(50);

    this.setToken(token);

    return token;
  },
};
